import { buildUrl } from '@lucidlink/workspacemanagement';
import { MANAGEMENT_PLATFORM_PATHS } from '#constants';
export const managementPlatformRoutes = {
    root: () => buildUrl(MANAGEMENT_PLATFORM_PATHS.root),
    dashboard: (contextOrgId) => buildUrl(MANAGEMENT_PLATFORM_PATHS.dashboard, { contextOrgId }),
    details: (contextOrgId) => buildUrl(MANAGEMENT_PLATFORM_PATHS.details, { contextOrgId }),
    organization: (contextOrgId, organizationId) => buildUrl(MANAGEMENT_PLATFORM_PATHS.organization, {
        contextOrgId,
        organizationId,
    }),
    organizationClients: (contextOrgId, organizationId) => buildUrl(MANAGEMENT_PLATFORM_PATHS.organizationClients, {
        contextOrgId,
        organizationId,
    }),
    organizationCreateContract: (contextOrgId, organizationId) => buildUrl(MANAGEMENT_PLATFORM_PATHS.organizationCreateContract, {
        contextOrgId,
        organizationId,
    }),
    organizationPreviewContract: (contextOrgId, organizationId) => buildUrl(MANAGEMENT_PLATFORM_PATHS.organizationPreviewContract, {
        contextOrgId,
        organizationId,
    }),
    organizationPrepareUpgrade: (contextOrgId, organizationId) => buildUrl(MANAGEMENT_PLATFORM_PATHS.organizationPrepareUpgrade, {
        contextOrgId,
        organizationId,
    }),
    organizationSetupFilespaceUpgrade: (contextOrgId, organizationId) => buildUrl(MANAGEMENT_PLATFORM_PATHS.organizationSetupFilespaceUpgrade, {
        contextOrgId,
        organizationId,
    }),
    organizationViewFilespaceUpgrade: (contextOrgId, organizationId) => buildUrl(MANAGEMENT_PLATFORM_PATHS.organizationViewFilespaceUpgrade, {
        contextOrgId,
        organizationId,
    }),
    organizationMigrateContract: (contextOrgId, organizationId) => buildUrl(MANAGEMENT_PLATFORM_PATHS.organizationMigrateContract, {
        contextOrgId,
        organizationId,
    }),
    organizationUpsell: (contextOrgId, organizationId) => buildUrl(MANAGEMENT_PLATFORM_PATHS.organizationUpsell, {
        contextOrgId,
        organizationId,
    }),
    apiKey: (contextOrgId) => `/management-platform/${contextOrgId}/api-key`,
};
